import type { ContentItem } from "../types/contractTemplate";

/** Backend / KB-friendly content row (snake_case for optional HTML). */
export type ApiContentBlock = {
  type: string;
  text: string;
  text_as_html?: string;
};

export function contentItemsToApiPayload(content: readonly ContentItem[]): ApiContentBlock[] {
  return content.map((item) => {
    if (item.type === "table") {
      const row: ApiContentBlock = { type: "table", text: item.text };
      if (item.textAsHtml?.trim()) row.text_as_html = item.textAsHtml.trim();
      return row;
    }
    if (item.type === "list_item") {
      return { type: "list_item", text: item.text };
    }
    return { type: "paragraph", text: item.text };
  });
}

export function contentHasSomeText(content: readonly ContentItem[]): boolean {
  return content.some((c) => c.text.trim().length > 0);
}
